import { deliveryPackageConstants } from "@constants";

const initalState = {
  query: {
    loading: false,
    constructionUuid: null,
    condition: {},
    total: 0,
    items: [],
    fail: null
  }
};

export const deliveryPackages = (state = initalState, action) => {
  switch (action.type) {
    case deliveryPackageConstants.GET_ALL_REQUEST:
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: true
        }
      };
    case deliveryPackageConstants.GET_ALL_SUCCESS:
      const { total, items, condition, constructionUuid } = action;

      /**
       * 2023-05-29
       * 後端將原貨運包裹的狀態改成 history 的陣列格式，但前端畫面呈現未調整，故將後端資料轉換成前端原本的格式。
       * 後續若有要將頁面呈現成開窗的方式呈現 history 的話，就不用此段轉換，直接將 history 內容輸出至畫面。
       **/
      const converedItems = items.map(item => {
        const { history } = item;

        let converedFields = history.reduce((acc, cur) => {
          const { files, status: currentStatus, note, created_at } = cur;
          switch (currentStatus) {
            case "wait_collect":
              acc["delivery_package_files"] = files;
              acc["note"] = note;
              break;
            case "collected_by_self":
              acc["collected_record_files"] = files;
              acc["collected_at"] = created_at;
              break;
            case "wait_return":
              acc["wait_return_package_files"] = files;
              acc["wait_return_note"] = note;
              break;
            case "returned":
              acc["returned_at"] = created_at;
              acc["returned_record_files"] = files;
              break;
            default:
              break;
          }

          return acc;
        }, {});

        return {
          ...item,
          ...converedFields
        };
      });

      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          constructionUuid,
          condition,
          total,
          items: converedItems
        }
      };
    case deliveryPackageConstants.GET_ALL_FAILURE:
      const { error } = action;
      return {
        ...state,
        query: {
          ...initalState.query,
          loading: false,
          fail: error
        }
      };
    case deliveryPackageConstants.RESET_ALL_SUCCESS:
      return initalState;
    default:
      return state;
  }
};
